import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {BaseModalComponent} from '../base-modal.component';
import {ModalService} from '../../../services/modal.service';

@Component({
  selector: 'mypart-lyrics',
  templateUrl: './lyrics.component.html',
  styleUrl: './lyrics.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LyricsComponent extends BaseModalComponent implements AfterViewInit {
  @Input() title!: string;
  @Input() artist!: string;
  @Input() lyrics!: string;

  @ViewChild('lyricsContent', { read: ElementRef }) lyricsContent?: ElementRef<HTMLElement>;
  @ViewChild('lyricsWrapper', { read: ElementRef }) lyricsWrapper?: ElementRef<HTMLElement>;

  constructor(modalService: ModalService) {
    super(modalService);
  }

  ngAfterViewInit() {
    this.initModal({
      backdrop: 'dynamic',
      closable: false
    });

    // Set up scroll event listener for fade indicators
    setTimeout(() => {
      this.updateScrollIndicators();
      this.lyricsContent?.nativeElement.addEventListener('scroll', () => {
        this.updateScrollIndicators();
      });
    }, 0);
  }

  private updateScrollIndicators(): void {
    const element = this.lyricsContent?.nativeElement;
    const wrapper = this.lyricsWrapper?.nativeElement;

    if (!element || !wrapper) return;

    const isAtTop = element.scrollTop <= 10;
    const isAtBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - 10;

    if (isAtTop) {
      wrapper.classList.add('is-scrolled-top');
    } else {
      wrapper.classList.remove('is-scrolled-top');
    }

    if (isAtBottom) {
      wrapper.classList.add('is-scrolled-bottom');
    } else {
      wrapper.classList.remove('is-scrolled-bottom');
    }
  }
}
